var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',{staticClass:"ar-icon ar-icon__xs ar-icon--no-border",attrs:{"id":"download","name":"download"},nativeOn:{"click":function($event){return _vm.download.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }